module.exports = __webpack_public_path__ + "assets/img/n5.b913f16d.png";